var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9c4f3b",
    d: "M2 3h14a2 2 0 110 4H2a2 2 0 110-4zm6 7h14a2 2 0 110 4H8a2 2 0 110-4zm-6 7h14a2 2 0 110 4H2a2 2 0 110-4z",
    transform: "translate(.333)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 0H13V24H12z",
    transform: "translate(.333)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.7f7f1fbe2a0b6950c5a19133fde16ac6.svg";
export { ForwardRef as ReactComponent };